import React from 'react';
import { FormattedMessage } from 'react-intl';
import { GenericNotification } from './GenericNotification';
import { AsyncNotificationStatus } from '../../../utils/hooks/useNotificator/useNotificator.types';

const getNotificationKey = (itemsCount: number, status: AsyncNotificationStatus) => {
  if (itemsCount === 0) {
    return status === AsyncNotificationStatus.Pending
      ? 'files-manager.empty-trash-notification.pending'
      : 'files-manager.empty-trash-notification.done';
  }
  return status === AsyncNotificationStatus.Pending
    ? 'files-manager.delete-forever-notification.pending'
    : 'files-manager.delete-permanently-modal-success-toast';
};
interface PermanentDeleteSuccessNotificationArgs {
  itemsCount: number;
  itemName?: string;
  isAsyncSourcedFilesCount?: boolean;
}
export const permanentDeleteSuccessNotification =
  ({ itemsCount, itemName = '', isAsyncSourcedFilesCount = false }: PermanentDeleteSuccessNotificationArgs) =>
  ({ notification }) =>
    isAsyncSourcedFilesCount && (notification.status === AsyncNotificationStatus.Pending || itemsCount === 0) ? null : (
      <GenericNotification
        notification={notification}
        text={
          <FormattedMessage
            id={getNotificationKey(itemsCount, notification.status)}
            values={{
              itemsCount,
              itemName,
            }}
          />
        }
        dataHook="permanent-delete-success-notification"
      />
    );
